import { useState, useCallback } from 'react';

export interface UseCopyToClipboardReturn {
  isCopied: Record<string, boolean>;
  copyToClipboard: (text: string | null | undefined, id: string) => void;
}

/**
 * Hook for copying text to clipboard with visual feedback
 * Tracks copied state per unique ID to support multiple copy buttons
 */
export function useCopyToClipboard(): UseCopyToClipboardReturn {
  const [isCopied, setIsCopied] = useState<Record<string, boolean>>({});

  const copyToClipboard = useCallback((text: string | null | undefined, id: string) => {
    if (!text) return;

    navigator.clipboard.writeText(text).then(
      () => {
        setIsCopied((prev) => ({ ...prev, [id]: true }));
        setTimeout(() => {
          setIsCopied((prev) => ({ ...prev, [id]: false }));
        }, 2000);
      },
      (err) => {
        console.error('Could not copy text: ', err);
      }
    );
  }, []);

  return { isCopied, copyToClipboard };
}
